import React from 'react';
import { Label } from 'components/inputs/Label';
import './GridPopup.less';
import { PopupButtons, IPopupButtonsProps } from './PopupButtons';
import classNames from 'classnames';
import { DataAttributeProps, getDataAttributes } from 'utils/DataAttributeUtils';
import { ValidationSummary } from 'utils/ValidationUtils';
import { ValidationWrapper } from 'components/inputs/Validation/ValidationWrapper';

export interface IGridPopupProps extends DataAttributeProps, IPopupButtonsProps {
  label?: string;
  value?: string;
  children?: React.ReactNode;
  className?: string;
  'data-testid'?: string;
  placeholder?: string;
  hideLabel?: boolean;
  validation?: ValidationSummary;
}

const getClassName = (className?: string) => classNames('dpc-grid-popup-display', className);

const getContentClassName = (showPlaceHolder: boolean) =>
  classNames({
    'dpc-grid-popup-display__read-only-value': !showPlaceHolder,
    'dpc-grid-popup-display__placeholder': showPlaceHolder,
  });

/**
 * Basic Grid Popup elements.
 *
 * Copyright (c) 2019 Decisions ALl Rights Reserved
 */
export function GridPopup(props: IGridPopupProps) {
  const placeholder = props.placeholder ?? 'Click edit icon to choose';
  const showPlaceHolder = props.children === undefined && !props.value;
  const value = showPlaceHolder ? placeholder : props.value;
  const contentClass = getContentClassName(showPlaceHolder);
  const dataAttributes = showPlaceHolder ? getDataAttributes(props) : {};
  const content = (
    <ValidationWrapper validation={props.validation}>
      <div className="dpc-grid-popup-display" {...dataAttributes}>
        <div className={contentClass} title={value}>
          {props.children !== undefined ? props.children : value}
        </div>
        <PopupButtons {...props} />
      </div>
    </ValidationWrapper>
  );
  return props.hideLabel ? (
    content
  ) : (
    <Label
      label={props.label}
      className={getClassName(props.className)}
      data-testid={props['data-testid']}
      dataLabel={props.dataLabel}
      dataPath={props.dataPath}
    >
      {content}
    </Label>
  );
}
